"use strict";

exports.__esModule = true;
exports.isTraceOption = isTraceOption;
exports.makeTracingHeaders = makeTracingHeaders;
exports.parseTracingOptions = parseTracingOptions;
var _match = require("./match");
var _is = require("./is");
function isTraceOption(option) {
  return option && (0, _match.isMatchOption)(option.match) && (0, _is.isArray)(option.propagatorTypes);
}
function makeTracingHeaders(traceId, spanId, sampled, propagatorTypes, subOption) {
  if (subOption === void 0) {
    subOption = {};
  }
  var tracingHeaders = {};
  var sample = sampled ? '1' : '0';
  // skywalking 标准具备排他性，如果包含sw8，则只使用sw8
  if (propagatorTypes.includes('sw8')) {
    propagatorTypes = ['sw8'];
  }
  propagatorTypes.forEach(function (propagatorType) {
    switch (propagatorType) {
      case 'jaeger':
        tracingHeaders['uber-trace-id'] = traceId + ":" + spanId + ":0:" + sample;
        break;
      case 'b3':
        // https://github.com/openzipkin/b3-propagation
        tracingHeaders['b3'] = traceId + "-" + spanId + "-" + sample;
        break;
      case 'b3multi':
        tracingHeaders['X-B3-TraceId'] = traceId;
        tracingHeaders['X-B3-SpanId'] = spanId;
        tracingHeaders['X-B3-Sampled'] = sample;
        break;
      case 'sw8':
        if ((0, _is.isFunction)(btoa)) {
          // https://github.com/apache/skywalking-client-js
          var traceIdStr = btoa(traceId);
          var segmentId = btoa(spanId);
          var service = btoa(subOption.appId);
          var instance = btoa(subOption.appVersion);
          var endpoint = btoa(subOption.viewName);
          var peer = btoa(subOption.host);
          tracingHeaders['sw8'] = sample + "-" + traceIdStr + "-" + segmentId + "-" + 0 + "-" + service + "-" + instance + "-" + endpoint + "-" + peer;
        }
        break;
      case 'tracecontext':
      default:
        // https://www.w3.org/TR/trace-context/
        tracingHeaders['traceparent'] = "00-" + traceId + "-" + spanId + "-0" + sample;
        if (subOption.tracestate) {
          tracingHeaders['tracestate'] = subOption.tracestate;
        }
        break;
    }
  });
  if (subOption.baggage) {
    tracingHeaders['baggage'] = subOption.baggage;
  }
  return tracingHeaders;
}
function parseTracingOptions(tracingOption) {
  var defPropagatorTypes = ['tracecontext'];
  if ((0, _is.isBoolean)(tracingOption) || !tracingOption) {
    return {
      enable: !!tracingOption,
      sample: 100,
      propagatorTypes: defPropagatorTypes,
      allowedUrls: [],
      tracestate: true,
      baggage: false
    };
  }
  var _tracingOption$enable = tracingOption.enable,
    enable = _tracingOption$enable === void 0 ? true : _tracingOption$enable,
    _tracingOption$sample = tracingOption.sample,
    sample = _tracingOption$sample === void 0 ? 100 : _tracingOption$sample,
    _tracingOption$propag = tracingOption.propagatorTypes,
    propagatorTypes = _tracingOption$propag === void 0 ? defPropagatorTypes : _tracingOption$propag,
    _tracingOption$allowe = tracingOption.allowedUrls,
    allowedUrls = _tracingOption$allowe === void 0 ? [] : _tracingOption$allowe,
    _tracingOption$traces = tracingOption.tracestate,
    tracestate = _tracingOption$traces === void 0 ? true : _tracingOption$traces,
    _tracingOption$baggag = tracingOption.baggage,
    baggage = _tracingOption$baggag === void 0 ? false : _tracingOption$baggag;
  var traceOptions = [];
  if ((0, _is.isArray)(allowedUrls) && allowedUrls.length) {
    allowedUrls.forEach(function (item) {
      if ((0, _match.isMatchOption)(item)) {
        traceOptions.push({
          match: item,
          propagatorTypes: propagatorTypes
        });
      } else if (isTraceOption(item)) {
        traceOptions.push(item);
      }
    });
  }
  return {
    enable: (0, _is.isBoolean)(enable) ? enable : true,
    sample: (0, _is.isNumber)(sample) ? sample : 100,
    propagatorTypes: propagatorTypes,
    allowedUrls: traceOptions,
    tracestate: tracestate,
    baggage: baggage
  };
}